export const VUE_APP_PRODUCT_TABS = {
  ID: 'VUE_APP_PRODUCT_TABS',
  SCRIPT_ID: 'VUE_APP_PRODUCT_TABS_DATA',
  APP: async () => await import(/* webpackChunkName: 'VUE_APP_PRODUCT_TABS' */ './components/ProductTabContents.vue')
};

export const VUE_APP_PRODUCT_GALLERY = {
  ID: 'VUE_APP_PRODUCT_GALLERY',
  SCRIPT_ID: 'VUE_APP_PRODUCT_GALLERY_DATA',
  APP: async () => await import(/* webpackChunkName: 'VUE_APP_PRODUCT_GALLERY' */ './components/ProductGallery.vue')
}